export var BillingMode;
(function (BillingMode) {
    /** Legacy billing, manual intervention required */
    BillingMode["Legacy"] = "legacy";
    /** Fully automated billing */
    BillingMode["Default"] = "default";
    /** Hogast customers. We create invoices and additional documents
     * in a different format and send these to hogast-specific emails */
    BillingMode["Hogast"] = "hogast";
    /** Yearly billing is a flat price for a year, up to an agreed-upon employee limit */
    BillingMode["Yearly"] = "yearly";
    /** Lifetime billing is a one-time payment for lifetime access */
    BillingMode["Lifetime"] = "lifetime";
})(BillingMode || (BillingMode = {}));
/** Manual billing modes are the ones that need to be created manually in stripe.
 * We *do not* report active employee counts.
 * We *do* send invoices.
 */
export const ManualBillingModes = [BillingMode.Legacy, BillingMode.Lifetime, BillingMode.Yearly];
//# sourceMappingURL=billing-mode.js.map